import {useAsync2} from "nate-react-api-helpers";
import {api} from "../../api/API";
import {grey} from "@mui/material/colors";
import {BoardColumnEl} from "./BoardColumnEl";
import {BoardContextProvider} from "./BoardContextProvider";
import {AddBoardColumn} from "./AddBoardColumn";
import {Droppable, DroppableProvided} from "react-beautiful-dnd";
import {DropContextWrapper} from "./DropContextWrapper";
import {BoardSettingsButton} from "./board/BoardSettingsButton";

export function TaskBoard(props: {
    boardKey?: string;
    project?: number;
    user?: number;
}) {

    const board = useAsync2(input => api.tasks2.getBoard(input),
        {
            key: props.boardKey,
            project: props.project,
            user: props.user,
        },
        [props.boardKey, props.project, props.user]);

    const b = board.result;

    return (
        <div style={{
            backgroundColor: grey["200"],
            flex: 1,
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
        }}>
            {board.LoadingOrErrorElement}
            {b && <BoardContextProvider refresh={() => board.reload()} board={b}>
                <div style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    gap: 8,
                }}>
                    <div style={{
                        fontSize: "1.2rem",
                        fontWeight: "500",
                        color: grey["700"],
                        padding: 8,
                    }}>{b.title}</div>

                    <BoardSettingsButton />
                </div>

                <DropContextWrapper columns={b.columns||[]}>
                    <Droppable
                        droppableId="board"
                        type="BOARD"
                        direction="horizontal"
                    >
                        {(provided: DroppableProvided) => (
                            <div ref={provided.innerRef} {...provided.droppableProps}
                                 style={{
                                     flex: 1,
                                     display: "flex",
                                     flexDirection: "row",
                                     alignItems: "stretch",
                                     flexWrap: "nowrap",
                                     overflowX: "auto",
                                     overflowY: "hidden",
                                 }}
                            >
                                {(b?.columns || []).map((c, index) => (
                                    <BoardColumnEl key={c.id} value={c} index={index} />
                                ))}

                                <AddBoardColumn board={b?.id || 0} />
                                {provided.placeholder}
                            </div>
                        )}
                    </Droppable>
                </DropContextWrapper>
            </BoardContextProvider>}
        </div>
    )
}